import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DatePickerController } from './date-picker.service';

@Directive({
    selector: '[datePicker]'
})
export class DatePickerDirective {

    @Input() datePicker;
    @Output() datePickerChange : EventEmitter<any> = new EventEmitter<any>();
    @Input() type;


    constructor(private el: ElementRef, private datePickerCtrl: DatePickerController) {
    }

    @HostListener('click') onClick() {
        this.datePickerCtrl.show(this.el, this.datePickerChange);
    }

}
